/* eslint-disable */
import axios from 'axios'
import qs from 'qs'
let domain = ''
export const getDomain = () => {
  return domain
}
export const setDomain = ($domain) => {
  domain = $domain
}
export const request = (method, url, body, queryParameters, form, config) => {
  method = method.toLowerCase()
  let keys = Object.keys(queryParameters)
  let queryUrl = url
  if (keys.length > 0) {
    queryUrl = url + '?' + qs.stringify(queryParameters)
  }
  // let queryUrl = url+(keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
  if (body) {
    if (method === 'delete') {
      return axios[method](queryUrl, {
        data: body
      }, config)
    }
    return axios[method](queryUrl, body, config)
  } else if (method === 'get') {
    return axios[method](queryUrl, {
      params: form
    }, config)
  } else {
    return axios[method](queryUrl, qs.stringify(form), config)
  }
}
/*==========================================================
 *                    
 ==========================================================*/
/**
 * 
 * request: Comission_Get
 * url: Comission_GetURL
 * method: Comission_Get_TYPE
 * raw_url: Comission_Get_RAW_URL
 * @param from - 
 * @param to - 
 * @param page - 
 * @param pageSize - 
 */
export const Comission_Get = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/comission'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['from'] !== undefined) {
    queryParameters['from'] = parameters['from']
  }
  if (parameters['to'] !== undefined) {
    queryParameters['to'] = parameters['to']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Comission_Get_RAW_URL = function() {
  return '/comission'
}
export const Comission_Get_TYPE = function() {
  return 'get'
}
export const Comission_GetURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/comission'
  if (parameters['from'] !== undefined) {
    queryParameters['from'] = parameters['from']
  }
  if (parameters['to'] !== undefined) {
    queryParameters['to'] = parameters['to']
  }
  if (parameters['page'] !== undefined) {
    queryParameters['page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['pageSize'] = parameters['pageSize']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}
/**
 * 
 * request: Comission_GetAsCsv
 * url: Comission_GetAsCsvURL
 * method: Comission_GetAsCsv_TYPE
 * raw_url: Comission_GetAsCsv_RAW_URL
 * @param from - 
 * @param to - 
 */
export const Comission_GetAsCsv = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/comission/csv'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['from'] !== undefined) {
    queryParameters['from'] = parameters['from']
  }
  if (parameters['to'] !== undefined) {
    queryParameters['to'] = parameters['to']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    });
  }
  return request('get', domain + path, body, queryParameters, form, config)
}
export const Comission_GetAsCsv_RAW_URL = function() {
  return '/comission/csv'
}
export const Comission_GetAsCsv_TYPE = function() {
  return 'get'
}
export const Comission_GetAsCsvURL = function(parameters = {}) {
  let queryParameters = {}
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  let path = '/comission/csv'
  if (parameters['from'] !== undefined) {
    queryParameters['from'] = parameters['from']
  }
  if (parameters['to'] !== undefined) {
    queryParameters['to'] = parameters['to']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] = parameters.$queryParameters[parameterName]
    })
  }
  let keys = Object.keys(queryParameters)
  return domain + path + (keys.length > 0 ? '?' + (keys.map(key => key + '=' + encodeURIComponent(queryParameters[key])).join('&')) : '')
}